export default __webpack_public_path__ + "static/media/Image1.9163e880.JPG";